// Shared site-wide footer. Renders on every public/auth page so the legal
// links are reachable from anywhere in the app. Single external URL — we do
// NOT host duplicated legal content in-app.
const LEGAL_URL = "https://sdrive-transfert.fr/legal-information/";

export default function PublicFooter({ className = "" }) {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="public-footer"
      className={`mt-auto border-t border-zinc-900/80 bg-[#050505] ${className}`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 text-center text-[11px] text-zinc-500 space-y-1.5">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <a
            data-testid="footer-cgu"
            href={LEGAL_URL}
            target="_blank"
            rel="noopener noreferrer external"
            className="hover:text-amber-400 underline-offset-2 hover:underline"
          >
            Conditions générales
          </a>
          <span className="text-zinc-700">·</span>
          <a
            data-testid="footer-mentions"
            href={LEGAL_URL}
            target="_blank"
            rel="noopener noreferrer external"
            className="hover:text-amber-400 underline-offset-2 hover:underline"
          >
            Mentions légales
          </a>
          <span className="text-zinc-700">·</span>
          <a
            data-testid="footer-privacy"
            href={LEGAL_URL}
            target="_blank"
            rel="noopener noreferrer external"
            className="hover:text-amber-400 underline-offset-2 hover:underline"
          >
            Politique de confidentialité
          </a>
        </div>
        <p className="text-[10px] text-zinc-600">© {year} Sdrive Transfert</p>
      </div>
    </footer>
  );
}

export { LEGAL_URL };
